/**
 * Guided Rock onboarding steps (ROCK-ONBOARDING-REWORK T5): the controls
 * inside Discover, Measurements ("Let Graphit set this up", 25i), Review
 * (starter dashboard) and Summary on the full-screen
 * `/setup/rock/:id` route, plus the checklist's AI "suggested" column.
 */

const ROUTE = '/setup/rock/:id'
const BOARD_ROUTE = '/settings/integrations/rock/:id/measurements'
const ENTITY = 'rock_connection'
/** Rock connections have no object-level sharing: the admin role gate is the whole rule. */
const PERMISSION = 'view'

const anchor = (id, label, intent, extra = {}) => ({
  id: `integrations.onboarding.${id}`,
  label,
  intent,
  route: ROUTE,
  minRole: 'admin',
  entity: ENTITY,
  permission: PERMISSION,
  ...extra,
})

export const ROCK_ONBOARDING_STEP_ANCHORS = [
  anchor('discover_refresh', 'Refresh', 'Read the Rock again: metrics, campuses, service times, giving and attendance'),
  anchor('discover_stale_choice', 'Keep history / Skip', 'Keep a Rock metric that stopped updating for its history (never on the starter dashboard), or skip it'),
  anchor('next_create_standard', 'Create the standard measurements in Rock', 'Have Graphit create weekend attendance, giving and the other standard measurements in Rock'),
  anchor('next_link_pco', 'Link Planning Center', 'Connect Planning Center to bring in check-ins and headcounts'),
  anchor('next_enter_manually', 'Enter numbers by hand', 'Type numbers into a data entry form'),
  anchor('next_import_spreadsheet', 'Import a spreadsheet', 'Upload a CSV or Excel file of past numbers'),
  anchor('auto_setup_start', 'Set up measurements', 'Have Graphit set up the measurements it picked from Rock, in the background'),
  anchor('auto_setup_list', 'Show the list', 'See each measurement Graphit will read from Rock, create in Rock, or skip, and why'),
  anchor('auto_setup_skip', 'Skip', 'Leave one measurement out of what Graphit sets up'),
  anchor('auto_setup_choose_manually', 'Choose manually', 'Pick the measurements yourself from the full checklist instead'),
  anchor('auto_setup_choose_row', 'Choose manually', 'Open the checklist at a measurement that needs your choice (group types, service times, accounts)'),
  anchor('setup_match_campuses', 'Match campuses', 'Match Rock campuses so the measurements waiting on them can be set up'),
  anchor('setup_retry', 'Retry', 'Try again for the measurements that couldn’t be set up'),
  anchor('review_remove_widget', 'Remove', 'Leave a widget off the starter dashboard (or put it back)'),
  anchor('review_create', 'Create dashboard', 'Create the reviewed starter dashboard'),
  anchor('review_skip', 'Skip for now', 'Go on without creating a starter dashboard'),
  anchor('review_build_again', 'Build again', 'Build the starter dashboard proposal again after something changed'),
  anchor('review_build_now', 'Build now anyway', 'Build the starter dashboard before every measurement has its first values'),
  anchor('review_open_dashboard', 'Open dashboard', 'Open the starter dashboard just created'),
  anchor('summary_go_dashboard', 'Go to dashboard', 'Leave Rock setup and open the starter dashboard'),
  anchor('summary_finish', 'Finish', 'Leave Rock setup for the Getting Started checklist'),
  anchor('summary_link_pco', 'link Planning Center', 'After Rock setup, connect Planning Center to bring in check-ins and headcounts'),
  anchor('summary_enter_manually', 'enter numbers by hand', 'After Rock setup, type numbers into a data entry form'),
  anchor('summary_import_spreadsheet', 'import a spreadsheet', 'After Rock setup, upload a CSV or Excel file of past numbers'),
  {
    id: 'integrations.setup.suggested',
    label: 'Suggested',
    intent: 'See which Rock metric Graphit suggests for each measurement, and why',
    route: BOARD_ROUTE,
    minRole: 'admin',
    entity: ENTITY,
    permission: PERMISSION,
    parent: 'integrations.setup.checklist',
  },
]
